import { render, staticRenderFns } from "./OrdersPacked.vue?vue&type=template&id=d44fb29c&"
import script from "./OrdersPacked.vue?vue&type=script&lang=js&"
export * from "./OrdersPacked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports